import { Box, FormControl, InputAdornment, InputLabel, OutlinedInput, OutlinedTextFieldProps } from '@mui/material'
import randomBytes from 'randombytes'
import React from 'react'

import xyoLogo from './img/xyo.svg'

const StartAdornment: React.FC = () => (
  <InputAdornment position="start">
    <Box
      height={20}
      marginRight={1}
      style={{ backgroundImage: `url(${xyoLogo})`, backgroundPosition: 'center', backgroundSize: 'cover' }}
      width={20}
    />
  </InputAdornment>
)

interface XyoTextField extends OutlinedTextFieldProps {
  readOnly?: boolean
}

const XyoTextField: React.FC<XyoTextField> = (props) => {
  const { value, disabled, readOnly } = props
  const fontFamily = 'Source Code Pro'
  const id = randomBytes(8).toString()
  return (
    <FormControl fullWidth={props.fullWidth} variant="outlined">
      <InputLabel htmlFor={id}>{props.label}</InputLabel>
      <OutlinedInput
        disabled={disabled}
        fullWidth
        id={id}
        inputProps={{ style: { fontFamily, textAlign: 'end' } }}
        label={props.label}
        onChange={props.onChange}
        readOnly={readOnly}
        startAdornment={<StartAdornment />}
        value={value}
      />
    </FormControl>
  )
}

export default XyoTextField
